import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SendOutlinedSvg from "@ant-design/icons-svg/es/asn/SendOutlined";
import AntdIcon from "../components/AntdIcon";
var SendOutlined = function SendOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SendOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SendOutlined.displayName = 'SendOutlined';
}
export default /*#__PURE__*/React.forwardRef(SendOutlined);